export default __webpack_public_path__ + "static/media/main_banner_kit.f1dd4f96.png";